<template>
  <div id="SeloAps2">
    <div class="page-container">
      <div class="container">
        <header>
          <h1 id="prefeituraNome">{{ _municipio }}</h1>
        </header>

        <div class="c-content">
          <div class="left-column">
            <div class="c-content-header">
              <div class="coluna coluna-esquerda-header">
                <img
                  src="@/assets/images/previne-brasil/desempenho2/previne.png"
                  alt="Previne"
                  class="previne-image"
                />
              </div>
              <div>
                <h1 class="data-indicadores">{{ _quadrimestre }}</h1>
              </div>
              <div></div>
              <div>
                <h1 class="indicador-isf">ISF {{ _isf }}</h1>
              </div>
            </div>

            <div class="trophy-bg">
              <img
                :src="_trofeu"
                alt="Troféu"
                class="trophy-image"
                id="trophyImage"
              />
              <img
                src="@/assets/images/previne-brasil/desempenho2/esus.png"
                alt="e-SUS"
                class="logoEsus"
              />
            </div>
          </div>

          <div class="right-column">
            <div
              v-for="indicador in _indicadores"
              :key="indicador.name"
              class="indicador"
            >
              <p :class="['tag', indicador.color]">
                {{ indicador.name }}
              </p>
              <span class="container-position">
                <span class="larger-text">{{ indicador.position }}</span>
                <span class="larger-text">º</span>
                <span class="smaller-text"> Lugar</span>
              </span>
            </div>
          </div>
        </div>
        <p class="roda-pe">*{{ _macroRegiao }}</p>
        <p class="roda-pe">**{{ _regiaoSaude }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeloAps2',
  props: {
    options: {
      type: Object,
      required: false,
      default: {},
    },
  },
  data() {
    return {}
  },
  computed: {
    _isf() {
      if (
        this.options &&
        this.options.items &&
        Object.keys(this.options.items).length > 0
      ) {
        const indicadores = this.dadosFormated(this.options.items, 'isf')
        return parseFloat(indicadores)
      }
      return ''
    },
    _quadrimestre() {
      if (this.options) {
        return this.options.quadrimestre
      }
      return ''
    },
    _municipio() {
      if (
        this.options &&
        this.options.items &&
        Object.keys(this.options.items).length > 0
      ) {
        return `${this.options.items.no_municipio} - ${this.options.items.no_uf}`
      }
      return ''
    },
    _macroRegiao() {
      if (
        this.options &&
        this.options.items &&
        Object.keys(this.options.items).length > 0
      ) {
        return this.options.items.no_macro_regiao
      }
    },
    _regiaoSaude() {
      if (
        this.options &&
        this.options.items &&
        Object.keys(this.options.items).length > 0
      ) {
        return this.options.items.no_regiao_saude
      }
    },
    _trofeu() {
      if (
        this.options &&
        this.options.items &&
        Object.keys(this.options.items).length > 0
      ) {
        const indicadoresPositions = [
          this.dadosFormated(this.options.items, 'ranking_regiao_ibge'),
          this.dadosFormated(this.options.items, 'ranking_regiao_saude'),
          this.dadosFormated(this.options.items, 'ranking_macro_regiao'),
          this.dadosFormated(this.options.items, 'ranking_uf'),
          this.dadosFormated(this.options.items, 'ranking_br'),
        ]
        if (indicadoresPositions.some((valor) => valor === 1)) {
          return require('@/assets/images/previne-brasil/desempenho2/trofeu_o.png')
        } else if (indicadoresPositions.some((valor) => valor === 2)) {
          return require('@/assets/images/previne-brasil/desempenho2/trofeu_p.png')
        } else if (indicadoresPositions.some((valor) => valor === 3)) {
          return require('@/assets/images/previne-brasil/desempenho2/trofeu_b.png')
        } else {
          return require('@/assets/images/previne-brasil/desempenho2/trofeu_n.png')
        }
      }
    },
    _indicadores() {
      if (
        this.options &&
        this.options.items &&
        Object.keys(this.options.items).length > 0
      ) {
        const saude = this.dadosFormated(
          this.options.items,
          'ranking_regiao_saude'
        )
        const macroRegiao = this.dadosFormated(
          this.options.items,
          'ranking_macro_regiao'
        )
        const rankingUf = this.dadosFormated(this.options.items, 'ranking_uf')
        const regiaoIbge = this.dadosFormated(
          this.options.items,
          'ranking_regiao_ibge'
        )
        const rankingBr = this.dadosFormated(this.options.items, 'ranking_br')

        const indicadores = [
          { name: 'Região Saúde**', position: saude, color: 'c-black' },
          { name: 'Macro Região*', position: macroRegiao, color: 'c-orange' },
          {
            name: this.options.items.no_uf,
            position: rankingUf,
            color: 'c-gray',
          },
          {
            name: this.options.items.regiao_ibge,
            position: regiaoIbge,
            color: 'c-green',
          },
          { name: 'Brasil', position: rankingBr, color: 'c-yellow' },
        ]
        indicadores.sort((a, b) => a.position - b.position)
        return indicadores
      }
    },
  },
  methods: {
    dadosFormated(item, name) {
      const indicador = JSON.parse(item.res_ind_sisab_esf).find(
        (item) => item.quadrimestre === this.options.quadrimestre
      )
      return indicador[name]
    },
    getColorByPosition(position) {
      switch (position) {
        case 1:
          return 'c-black'
        case 2:
          return 'c-yellow'
        case 3:
          return 'c-gray'
        case 4:
          return 'c-green'
        case 5:
          return 'c-orange'
        default:
          return 'c-default'
      }
    },
  },
}
</script>

<style scoped lang="scss" src="./styles.scss" />
